import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares '
import React, { useContext, useEffect, useMemo, useState } from 'react'
import _ from 'lodash'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import { Icon } from 'semantic-ui-react'
import { useBreadcrumbs } from 'global/cnr/contexts/useHelpers/useBreadcrumbs'
import { CreateMatchResult_withProvider } from 'projectSpecific/sports/create/CreateMatchResult'
import { matchUpdateTypes } from 'projectSpecific/sports/cnr/reducers/SportsSeasonReducer'
import SportsMatchProvider from 'projectSpecific/sports/cnr/contexts/SportsMatchContext'
import SportsEditMatchProvider from 'projectSpecific/sports/cnr/contexts/SportsEditMatchContext'
import MatchDetailsUpdate from './MatchDetailsUpdate'
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess'
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import { gEnums } from 'global/enums/globalEnums'

const _baseTypes = {
  options: 'options',
  matchResultTypes: 'matchResultTypes',
  matchResult: 'matchResult',
  matchOptions: 'matchOptions',
  matchOption: 'matchOption',
  realtimeScoring: 'realtimeScoring',
}

const _optionTypes = {
  realtimeScoring: 'realtimeScoring',
  matchResults: 'matchResults',
  matchOptions: 'matchOptions'
}

const _matchResultTypes = {
  setScores: 'setScores',
  matchScore: 'matchScore',
}

export const MatchResultSquares = ({ match_true }) => {

  const appUserAccess = useAppUserAccess()
  const { isSuperAdmin, displayName } = appUserAccess ?? {}

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext
  const { matches_info, details_info, currentSeason_info, sportsKey, sportsShowOptions, sportPermissions, sportDataSettings, currentUserId } = sportsSeason_state ?? {}
  const { gameScoringType, gameAllowTies, _sportsModeSport } = currentSeason_info ?? {}
  const { useRtGameDayData } = sportDataSettings ?? {}
  const { matchKey: matchKey_sso } = sportsShowOptions ?? {}
  const { details } = details_info ?? {}
  const { sportsScoringAuthType } = details ?? {}


  const [allGroups, setAllGroups] = useState([])

  const currentGroup = allGroups?.[allGroups.length - 1]

  const { _results } = match_true ?? {}
  const { complete: complete_true } = _results ?? {}

  const iconProps = useMemo(() => {
    let icon = 'user'
    let color = 'green'
    let caption = 'Public'

    switch (sportsScoringAuthType) {
      case gEnums.sportsScoringAuthTypes.authUser:
        icon = 'user secret'
        color = 'red'
        caption = displayName ? displayName : 'Authorized Only'
        break;
      case gEnums.sportsScoringAuthTypes.appUser:
        icon = 'user'
        color = 'blue'
        caption = displayName ? displayName : 'App Users Only'
        break;
      case gEnums.sportsScoringAuthTypes.public:
        icon = 'users'
        color = 'green'
        caption = 'Public'
        break;
    }

    return { icon, color, caption }
  }, [sportsScoringAuthType])

  useEffect(() => {
    const _allGroups = []
    _allGroups.push({
      key: _baseTypes.options,
      value: '',
      caption: _.startCase(_baseTypes.options),
      menuItems: _optionTypes
    })
    setAllGroups(_allGroups)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  const addToGroup = (group) => {
    const _allGroups = _.clone(allGroups)
    _allGroups.push(group)
    setAllGroups(_allGroups)
  }

  const backLinks = useMemo(() => {
    const bl = _.map(
      allGroups.slice(0, -1),
      (group, index) => (
        {
          key: group.key || 0,
          caption: group.caption
        }
      )
    );
    return bl
  }, [allGroups])

  const goBack = () => {
    const _allGroups = _.clone(allGroups)
    if (_allGroups.length <= 1) { return; }
    const all_groups = _allGroups.slice(0, -1)
    setAllGroups(all_groups)
  }

  const goBackTo = (index) => {
    const _allGroups = _.clone(allGroups)
    if (index < 0 || index >= _allGroups.length) return;
    if (_allGroups.length <= 1) return; // ⛔ root protected 
    const all_groupz = _allGroups.slice(0, index + 1)
    setAllGroups(all_groupz)
  }

  const bcrb = useBreadcrumbs({ items: backLinks, onClick: goBackTo })

  const onClick_optionType = (value) => {
    switch (value) {
      case _optionTypes.matchResults:
        return addToGroup({ key: _baseTypes.matchResultTypes, value: value, caption: _.startCase(value), menuItems: _matchResultTypes })
      case _optionTypes.realtimeScoring:
        if (complete_true) { return; }
        return addToGroup({ key: _baseTypes.realtimeScoring, value: value, caption: _.startCase(value), menuItems: _optionTypes })
      case _optionTypes.matchOptions:
        if (!isSuperAdmin) { return; }
        return addToGroup({ key: _baseTypes.matchOptions, value: value, caption: _.startCase(value), menuItems: _optionTypes })
    }
  }

  const onClick_matchResultType = (value) => {
    addToGroup({ key: _baseTypes.matchResult, value: value, caption: _.startCase(value), menuItems: _matchResultTypes })
  }

  const onClick_matchOptions = (value) => {
    addToGroup({ key: _baseTypes.matchOption, value: value, caption: _.startCase(value), menuItems: _matchResultTypes })
  }

  const fnAltContent_options = (item) => {
    let icns = []
    switch (item) {
      case _optionTypes.matchResults:
        icns.push(<Icon name={iconProps.icon} color={iconProps.color} title={iconProps.caption} />)
        icns.push(<Icon name={'check circle'} color={complete_true ? 'green' : 'blue'} />)
        break;
      case _optionTypes.realtimeScoring:
        icns.push(<Icon name={iconProps.icon} color={iconProps.color} title={iconProps.caption} />)
        icns.push(<Icon name={complete_true ? 'ban' : 'check'} color={complete_true ? 'red' : 'blue'} />)
        break;
      case _optionTypes.matchOptions:
        icns.push(<Icon name={!isSuperAdmin ? 'ban' : 'check'} color={!isSuperAdmin ? 'red' : 'blue'} />)
        break;
      default:
      // nothing
    }
    return icns
  }

  const squares_options = (menuItems) => <ItemMenuSquares menuItems={menuItems} imsType={_imsTypes.inline} onClick={onClick_optionType} fn_altContent={fnAltContent_options} />
  const squares_matchResultType = (menuItems) => <ItemMenuSquares menuItems={menuItems} imsType={_imsTypes.inline} onClick={onClick_matchResultType} />
  const squares_matchOptions = (menuItems) => <ItemMenuSquares menuItems={menuItems} imsType={_imsTypes.inline} onClick={onClick_matchOptions} />

  const content = () => {
    if (allGroups) {
      const { key, menuItems, value } = currentGroup ?? {}
      switch (key) {
        case _baseTypes.options:
          return squares_options(menuItems)
        case _baseTypes.matchResultTypes:
          return squares_matchResultType(menuItems)
        case _baseTypes.matchOptions:
          return squares_matchOptions(matchUpdateTypes)
        case _baseTypes.matchResult:
          return <CreateMatchResult_withProvider matchKey={match_true?._itemKey} matchResultType={value} />
        case _baseTypes.realtimeScoring:
          return <div>Realtime Scoring</div>
        case _baseTypes.matchOption:
          return <SportsMatchProvider match={match_true} matchKey={match_true._itemKey} matchUpdateType={value}>
            <SportsEditMatchProvider matchUpdateType={value}>
              <MatchDetailsUpdate match={match_true} matchUpdateType={value} />
            </SportsEditMatchProvider>
          </SportsMatchProvider>
      }
    }
  }

  const header_top = () => {
    const currentGroup = allGroups?.[allGroups.length - 1]
    const { caption, key } = currentGroup ?? {}
    const _caption = caption || _.startCase(key)
    return <div className='swr-header'>
      {bcrb}
      <div className='swr-header-cap'><Icon color={'blue'} name='arrow left' onClick={(e) => goBack()}></Icon>{_caption}</div>
    </div>
  }

  return (
    <Wrapper
      topper={`${match_true?._status?.matchName} - ${displayName || 'Public'}`}
      header={header_top()}
      content={content()}
      wrapperType={wrapperTypes.paddedHeader}
    ></Wrapper>
  )
}
